module.exports = __webpack_public_path__ + "static/media/Kartana_gaussian2.c46bc0e2.png";